<template>
  <div>
    <section class="white-card top-tip">
      <h3 style="text-align: center">博主有话说</h3>
      <p>
        如果你认为你有好的建议或者文章随笔要给到我,那么可以编辑完文章投稿给我,审核通过,
        就会采纳你的建议/文章随笔。
      </p>
      <p>
        禁止发表涉及黄赌毒的文章及其他不当言论!希望您遵守好道德底线,和我一起为干净的网络环境
        贡献一份力量,多谢合作!
      </p>
    </section>

    <section class="white-card">
      <section class="white-card" style="height: 500px">
        <mavon-editor :toolbars="markdownOption" placeholder="输入随笔正文(投诉/建议)" v-model.trim="txt" @change="changeTxt"
          style="height: 100%" />
      </section>

      <!-- <section style="border: 1px solid #ccc" class="white-card">
      <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editor"
        :defaultConfig="toolbarConfig"
        :mode="mode"
      />
      <Editor
        style="height: 500px; overflow-y: hidden"
        v-model="txt"
        :defaultConfig="editorConfig"
        :mode="mode"
        @onCreated="onCreated"
      />
    </section> -->

      <section class="btn-wrap">
        <button class="primary-btn" @click.stop="showDialog">确认投稿</button>
      </section>
    </section>

    <!-- 弹框填写信息 -->
    <div>
      <popup :visible="dialogShow" :bgColor="'#fff'" @hide="hide">
        <section>
          <h3 style="text-align: center">投递信息</h3>
          <section class="row">
            <span>昵称:</span>
            <div class="input-wrap">
              <input type="text" placeholder="请输入昵称(必填)" v-model.trim="params.author" />
            </div>
          </section>

          <section class="row">
            <span>邮箱:</span>
            <div class="input-wrap">
              <input type="text" placeholder="请输入邮箱(必填)" v-model.trim="params.authorEmail" />
            </div>
          </section>

          <section class="row">
            <span>类型:</span>
            <div class="input-wrap radio-wrap">
              <input type="radio" name="type" value="0" id="blog" v-model.trim="params.type" />
              <label for="blog">随笔</label>
              <input type="radio" name="type" value="1" id="opion" v-model="params.type" />
              <label for="opion">投诉/建议/其他</label>
            </div>
          </section>

          <section class="row" v-if="params.type == '0'">
            <span>标题:</span>
            <div class="input-wrap">
              <input type="text" placeholder="请输入随笔标题(必填)" v-model.trim="params.title" />
            </div>
          </section>

          <section class="row" v-if="params.type == '0'">
            <span>简介:</span>
            <div class="input-wrap">
              <input type="text" placeholder="请输入随笔简介(必填)" v-model.trim="params.blogDesc" />
            </div>
          </section>

          <section class="row" v-if="params.type == '0'">
            <span>分类:</span>
            <div class="input-wrap checkbox-wrap">
              <template v-for="(label, index) in labelList">
                <input type="checkbox" name="term" :value="label.termId" :id="label.name" :key="label.termId"
                  v-model="parent" />
                <label :for="label.name">{{ label.name }}</label>
              </template>
              <input type="checkbox" name="other" v-model="isOther" />
              <label for="other">其他分类</label>
            </div>
          </section>

          <section class="row" v-if="isOther">
            <span style="visibility: hidden">输入:</span>
            <div class="input-wrap search-wrap">
              <input type="text" placeholder="请输入其他分类" v-model.trim="term" />
              <span class="iconfont icon-lijitoudi" @click="addTerm"></span>
            </div>
          </section>

          <template v-if="params.type == '0'">
            <section class="row">
              <span>标签:</span>
              <div class="col" style="margin-left: 0">
                <tag-selector @gettag="getTag" ref="tagSelect"></tag-selector>
              </div>
            </section>
            <div class="tip">按回车或逗号增加标签</div>
          </template>

          <div class="btn-wrap">
            <button class="primary-btn cancel-btn" @click.stop="hide()">
              取消
            </button>
            <button class="primary-btn" @click.stop="submit()">提交</button>
          </div>
        </section>
      </popup>
    </div>
  </div>
</template>
<script>
import data from "./index.js";
export default data;
</script>
<style scoped src="./index.css"></style>